import { MembershipLevelType } from "../types";

export const AWAITING_CLIENT_VALIDATION: string = "awaiting_client_validation";
export const VOUCHER_IMAGE_CONTAINER_ID: string = "voucher-image-container";

export const PROCESSING_STATUSES = [
  "processing",
  "queued",
  "hdr_processing",
  "account_suggest_processing",
  "integration_check",
];
export const DONE_STATUSES = [
  "successful",
  "integration_processing",
  "integration_processed_successfully",
  "integration_processing_failed",
  "integration_processing_failed_internal_error",
];
export const ERP_PROCESSING_STATUSES = [
  "integration_processing",
  "integration_processing_failed_internal_error",
];
export const ON_HOLD_STATUSES = ["on_hold"];
export const READY_STATUSES = [AWAITING_CLIENT_VALIDATION];

export const SORT_FETCH_PARAMS = ["uploaded", "edited"];
export const ALLOWED_ROLES = [
  "owner",
  "administrator",
  "admin",
  "system_admin",
  "api_admin",
];
export const HIGHER_ADMIN_ROLES = ["system_admin", "api_admin"];
export const DISABLED_TASKS_FOR_BOX_MARK = [
  "catalog_creditor_id",
  "catalog_debitor_id",
];
export const DISABLED_FOR_TRAINING = [
  "voucher_type",
  "country",
  "catalog_debitor_id",
  "catalog_creditor_id",
];
export const REDIRECT_LINK =
  "https://paperflow.atlassian.net/servicedesk/customer/portal/3/topic/ba902e70-0116-4514-87cb-0e033d8ee849/article/6684829";

export const DEFAULT_VOUCHERS_PER_PAGE = 25;

export const MEMBERSHIP_LEVELS: MembershipLevelType[] = [
  "normal",
  "controller",
  "administrator",
  "owner",
];

export const ORGANIZATION_MEMBERSHIPS = "organization-memberships";

export const HOME_PAGE = "/";
export const LOGIN_PAGE = "/login";
export const FORGOT_PASSWORD_PAGE = "/forgot-password";
export const VOUCHERS_EDIT_PAGE = "/vouchers/edit";
export const ORGANIZATIONS_PAGE = "/organizations";
